import { render, staticRenderFns } from "./AlertWidget.vue?vue&type=template&id=01c779a8"
import script from "./AlertWidget.vue?vue&type=script&lang=js"
export * from "./AlertWidget.vue?vue&type=script&lang=js"
import style0 from "./AlertWidget.vue?vue&type=style&index=0&id=01c779a8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports